import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
export function BasePage(_a) {
    var children = _a.children;
    return (_jsx(Box, { children: _jsx(Box, { margin: "1rem", children: children }) }));
}
